// extracted by mini-css-extract-plugin
module.exports = {"jusbrasilExperienceAlert":"jusbrasil-experience_jusbrasilExperienceAlert__eBfBB"};